import router from '@/router';
import master from '@/api/master.js';
import test from '@/api/test.js';

export default {
    getListPriority({ commit }) {
        return new Promise((resolve, reject) => {
            master.getPriority().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_PRIORITY', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Priority' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getListVisitType({ commit }) {
        return new Promise((resolve, reject) => {
            master.getVisitType().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_VISIT_TYPE', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Visit Type' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getListInsurer({ commit }) {
        return new Promise((resolve, reject) => {
            master.getInsurer().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_INSURER', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Insurer' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getListWard({ commit }) {
        return new Promise((resolve, reject) => {
            master.getWard().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_WARD', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Ward' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getListPhysicians({ commit }) {
        return new Promise((resolve, reject) => {
            master.getPhysicians().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_PHYSICIANS', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Physicians' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getListAvailableTestPCR({ commit }) {
        return new Promise((resolve, reject) => {
            test.getAvailableTestPCR().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_AVAILABLE_TEST_PCR', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Available Test PCR' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getListAvailableTestClinic({ commit }) {
        return new Promise((resolve, reject) => {
            test.getAvailableTestClinic().then((response) => {
                if (response.data.status) {
                    var datas = response.data.data;
                    commit('GET_LIST_AVAILABLE_TEST_CLINIC', datas);
                    resolve(response);
                } else {
                    reject({ message: 'Fail Get List Available Test Clinic' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
};
